// Process <--COMMENTS ... COMMENTS--> comments
// These are stripped from the output entirely

import type StateInline from '../state-inline'

export default function comment(state: StateInline, silent: boolean): boolean {
  const start = state.pos
  const max = state.posMax

  // Check for opening <--COMMENTS
  if (start + 12 > max) return false

  const opening = state.src.slice(start, start + 12)
  if (opening !== '<--COMMENTS ') return false

  // Find closing COMMENTS-->
  const closeTag = ' COMMENTS-->'
  const closePos = state.src.indexOf(closeTag, start + 12)

  if (closePos === -1) return false

  // Skip the entire comment without creating any tokens
  if (!silent) {
    // Comments produce no output, so we don't push any tokens
    // This effectively removes them from the output
  }

  state.pos = closePos + closeTag.length
  return true
}
